export const ROLES = {
  ADMIN: 'admin',
  MANAGER: 'manager',
  ASSOCIATE: 'associate',
  BANKER: 'banker',
  CONSULTANCY: 'consultancy',
};

export const ROLE_LABELS = {
  [ROLES.ADMIN]: 'Admin',
  [ROLES.MANAGER]: 'Manager',
  [ROLES.ASSOCIATE]: 'Associate',
  [ROLES.BANKER]: 'Banker',
  [ROLES.CONSULTANCY]: 'Consultancy',
  student: 'Student',
};

export const ROLE_COLORS = {
  [ROLES.ADMIN]: '#D93025',
  [ROLES.MANAGER]: '#1A73E8',
  [ROLES.ASSOCIATE]: '#1E8E3E',
  [ROLES.BANKER]: '#A142F4',
  [ROLES.CONSULTANCY]: '#4285F4',
  student: '#4285F4',
};

export const STATUSES = {
  NEW_LEAD: 'New Lead',
  DOCUMENTS_PENDING: 'Documents Pending',
  DOCUMENTS_COMPLETED: 'Documents Completed',
  ASSIGNED_TO_BANKER: 'Assigned to Banker',
  UNDER_REVIEW: 'Under Review',
  QUERY_RAISED: 'Query Raised',
  APPROVED: 'Approved',
  SANCTIONED: 'Sanctioned',
  DISBURSED: 'Disbursed',
  CLOSED: 'Closed',
  REJECTED: 'Rejected',
  CANCELLED: 'Cancelled',
  HOLD: 'Hold',
};

export const STATUS_COLORS = {
  [STATUSES.NEW_LEAD]: '#1A73E8',
  [STATUSES.DOCUMENTS_PENDING]: '#F9AB00',
  [STATUSES.DOCUMENTS_COMPLETED]: '#1E8E3E',
  [STATUSES.ASSIGNED_TO_BANKER]: '#A142F4',
  [STATUSES.UNDER_REVIEW]: '#4285F4',
  [STATUSES.QUERY_RAISED]: '#D93025',
  [STATUSES.APPROVED]: '#1E8E3E',
  [STATUSES.SANCTIONED]: '#4285F4',
  [STATUSES.DISBURSED]: '#137333',
  [STATUSES.CLOSED]: '#5F6368',
  [STATUSES.REJECTED]: '#D93025',
  [STATUSES.CANCELLED]: '#9AA0A6',
  [STATUSES.HOLD]: '#F9AB00',
};

export const STATUS_FLOW = [
  STATUSES.NEW_LEAD,
  STATUSES.DOCUMENTS_PENDING,
  STATUSES.DOCUMENTS_COMPLETED,
  STATUSES.ASSIGNED_TO_BANKER,
  STATUSES.UNDER_REVIEW,
  STATUSES.APPROVED,
  STATUSES.SANCTIONED,
  STATUSES.DISBURSED,
  STATUSES.CLOSED,
];

export const STATUS_TRANSITIONS = {
  [STATUSES.NEW_LEAD]: [STATUSES.DOCUMENTS_PENDING, STATUSES.CANCELLED],
  [STATUSES.DOCUMENTS_PENDING]: [STATUSES.DOCUMENTS_COMPLETED, STATUSES.HOLD, STATUSES.CANCELLED],
  [STATUSES.DOCUMENTS_COMPLETED]: [STATUSES.ASSIGNED_TO_BANKER, STATUSES.HOLD, STATUSES.CANCELLED],
  [STATUSES.ASSIGNED_TO_BANKER]: [STATUSES.UNDER_REVIEW, STATUSES.REJECTED, STATUSES.HOLD, STATUSES.CANCELLED],
  [STATUSES.UNDER_REVIEW]: [STATUSES.QUERY_RAISED, STATUSES.APPROVED, STATUSES.REJECTED, STATUSES.HOLD, STATUSES.CANCELLED],
  [STATUSES.QUERY_RAISED]: [STATUSES.UNDER_REVIEW, STATUSES.REJECTED, STATUSES.CANCELLED],
  [STATUSES.APPROVED]: [STATUSES.SANCTIONED, STATUSES.CANCELLED],
  [STATUSES.SANCTIONED]: [STATUSES.DISBURSED, STATUSES.CANCELLED],
  [STATUSES.DISBURSED]: [STATUSES.CLOSED],
  [STATUSES.CLOSED]: [],
  [STATUSES.REJECTED]: [],
  [STATUSES.CANCELLED]: [],
  [STATUSES.HOLD]: [STATUSES.DOCUMENTS_PENDING, STATUSES.DOCUMENTS_COMPLETED, STATUSES.ASSIGNED_TO_BANKER, STATUSES.CANCELLED],
};

export const DOCUMENT_CATEGORIES = {
  STUDENT_KYC: 'student_kyc',
  ACADEMIC_MEMOS: 'academic_memos',
  SEMESTER_MEMOS: 'semester_memos',
  ADMISSION_TESTS: 'admission_tests',
  FINANCIAL_DOCS: 'financial_docs',
  AGRICULTURE_INCOME: 'agriculture_income',
  CO_APPLICANT: 'co_applicant',
  BUSINESS_DOCS: 'business_docs',
  SALARY_DOCS: 'salary_docs',
  HOUSE_PROOF: 'house_proof',
  CHEQUES: 'cheques',
  CIBIL_REPORTS: 'cibil_reports',
  EXTRA_DOCUMENTS: 'extra_documents',
};

export const COMPLETE_CATEGORY_PDF_SLOT = '__complete_category_pdf__';

export const DOCUMENT_CATEGORY_LABELS = {
  [DOCUMENT_CATEGORIES.STUDENT_KYC]: 'Student KYC',
  [DOCUMENT_CATEGORIES.ACADEMIC_MEMOS]: 'Academic Memos',
  [DOCUMENT_CATEGORIES.ADMISSION_TESTS]: 'Admission & Tests',
  [DOCUMENT_CATEGORIES.FINANCIAL_DOCS]: 'Financial Documents',
  [DOCUMENT_CATEGORIES.CO_APPLICANT]: 'Co-Applicant KYC',
  [DOCUMENT_CATEGORIES.BUSINESS_DOCS]: 'Business Documents',
  [DOCUMENT_CATEGORIES.SALARY_DOCS]: 'Salary Documents',
  [DOCUMENT_CATEGORIES.HOUSE_PROOF]: 'House Proof',
  [DOCUMENT_CATEGORIES.CHEQUES]: 'Security Cheques',
  [DOCUMENT_CATEGORIES.CIBIL_REPORTS]: 'CIBIL Reports',
  [DOCUMENT_CATEGORIES.SEMESTER_MEMOS]: 'Semester Memos',
  [DOCUMENT_CATEGORIES.AGRICULTURE_INCOME]: 'Agriculture Income',
  [DOCUMENT_CATEGORIES.EXTRA_DOCUMENTS]: 'Extra Documents',
};

export const DOCUMENT_CATEGORY_DESCRIPTIONS = {
  [DOCUMENT_CATEGORIES.STUDENT_KYC]: 'Aadhar (Front/Back), PAN, Passport, Photo',
  [DOCUMENT_CATEGORIES.ACADEMIC_MEMOS]: 'Semester Marksheets',
  [DOCUMENT_CATEGORIES.ADMISSION_TESTS]: 'Offer Letter, IELTS/TOEFL/GRE',
  [DOCUMENT_CATEGORIES.FINANCIAL_DOCS]: 'Experience Letter, Bank Statement',
  [DOCUMENT_CATEGORIES.CO_APPLICANT]: 'Aadhar, PAN, Photo',
  [DOCUMENT_CATEGORIES.BUSINESS_DOCS]: 'ITR, Business Proof',
  [DOCUMENT_CATEGORIES.SALARY_DOCS]: 'Bank Statement, Salary Slips',
  [DOCUMENT_CATEGORIES.HOUSE_PROOF]: 'House Tax, Current Bill',
  [DOCUMENT_CATEGORIES.CHEQUES]: '8 Security Cheques',
  [DOCUMENT_CATEGORIES.CIBIL_REPORTS]: 'Student, Father, Mother & Extra CIBIL Reports',
  [DOCUMENT_CATEGORIES.SEMESTER_MEMOS]: 'Upload multiple semester memos',
  [DOCUMENT_CATEGORIES.AGRICULTURE_INCOME]: 'Agri Income, Patta Passbook',
  [DOCUMENT_CATEGORIES.EXTRA_DOCUMENTS]: 'Additional documents uploaded by student',
};

export const DOCUMENT_SLOTS = {
  [DOCUMENT_CATEGORIES.STUDENT_KYC]: [
    { key: 'aadhar_front', label: 'Aadhar Front' },
    { key: 'aadhar_back', label: 'Aadhar Back' },
    { key: 'pan', label: 'PAN' },
    { key: 'passport', label: 'Passport' },
    { key: 'photo', label: 'Photo' },
  ],
  [DOCUMENT_CATEGORIES.ACADEMIC_MEMOS]: [
    { key: 'semester_1', label: 'Semester 1' },
    { key: 'semester_2', label: 'Semester 2' },
    { key: 'semester_3', label: 'Semester 3' },
    { key: 'semester_4', label: 'Semester 4' },
    { key: 'semester_5', label: 'Semester 5' },
    { key: 'semester_6', label: 'Semester 6' },
    { key: 'semester_7', label: 'Semester 7' },
    { key: 'semester_8', label: 'Semester 8' },
  ],
  [DOCUMENT_CATEGORIES.ADMISSION_TESTS]: [
    { key: 'offer_letter', label: 'Offer Letter' },
    { key: 'ielts_toefl_gre', label: 'IELTS / TOEFL / GRE' },
  ],
  [DOCUMENT_CATEGORIES.FINANCIAL_DOCS]: [
    { key: 'experience_letter', label: 'Experience Letter' },
    { key: 'bank_statement_6m', label: '6 Month Bank Statement' },
  ],
  [DOCUMENT_CATEGORIES.CO_APPLICANT]: [
    { key: 'co_aadhar_front', label: 'Aadhar Front' },
    { key: 'co_aadhar_back', label: 'Aadhar Back' },
    { key: 'co_pan', label: 'PAN' },
    { key: 'co_photo', label: 'Photo' },
  ],
  [DOCUMENT_CATEGORIES.BUSINESS_DOCS]: [
    { key: 'itr', label: 'ITR' },
    { key: 'business_proof', label: 'Business Proof' },
  ],
  [DOCUMENT_CATEGORIES.SALARY_DOCS]: [
    { key: 'salary_bank_statement', label: '6 Months Bank Statement' },
    { key: 'salary_slips', label: 'Salary Slips' },
  ],
  [DOCUMENT_CATEGORIES.HOUSE_PROOF]: [
    { key: 'house_tax', label: 'House Tax' },
    { key: 'current_bill', label: 'Current Bill' },
  ],
  [DOCUMENT_CATEGORIES.CHEQUES]: [
    { key: 'cheque_1', label: 'Cheque 1' },
    { key: 'cheque_2', label: 'Cheque 2' },
    { key: 'cheque_3', label: 'Cheque 3' },
    { key: 'cheque_4', label: 'Cheque 4' },
    { key: 'cheque_5', label: 'Cheque 5' },
    { key: 'cheque_6', label: 'Cheque 6' },
    { key: 'cheque_7', label: 'Cheque 7' },
    { key: 'cheque_8', label: 'Cheque 8' },
  ],
  [DOCUMENT_CATEGORIES.CIBIL_REPORTS]: [
    { key: 'student_cibil', label: 'Student CIBIL Report' },
    { key: 'father_cibil', label: 'Father CIBIL Report' },
    { key: 'mother_cibil', label: 'Mother CIBIL Report' },
    { key: 'extra_cibil_1', label: 'Extra CIBIL Report 1' },
    { key: 'extra_cibil_2', label: 'Extra CIBIL Report 2' },
    { key: 'extra_cibil_3', label: 'Extra CIBIL Report 3' },
  ],
  [DOCUMENT_CATEGORIES.SEMESTER_MEMOS]: [],
  [DOCUMENT_CATEGORIES.AGRICULTURE_INCOME]: [
    { key: 'agri_income', label: 'Agri Income' },
    { key: 'patta_passbook', label: 'Patta Passbook' },
  ],
  [DOCUMENT_CATEGORIES.EXTRA_DOCUMENTS]: [],
};

export const BRANCHES = ['Warangal', 'Hyderabad'];

export const LEAD_STATUSES = [
  { value: 'new_lead', label: 'New Lead', color: '#1A73E8' },
  { value: 'connected', label: 'Connected', color: '#4285F4' },
  { value: 'not_interested', label: 'Not Interested', color: '#D93025' },
  { value: 'interested', label: 'Interested', color: '#1E8E3E' },
];

export const ADMISSION_STATUSES = [
  { value: 'applied', label: 'Applied' },
  { value: 'conditional_offer', label: 'Conditional Offer' },
  { value: 'unconditional_offer', label: 'Unconditional Offer' },
  { value: 'confirmed', label: 'Confirmed' },
  { value: 'visa_applied', label: 'Visa Applied' },
  { value: 'visa_approved', label: 'Visa Approved' },
  { value: 'enrolled', label: 'Enrolled' },
];

export const VISA_STATUSES = [
  { value: 'not_applied', label: 'Not Applied' },
  { value: 'applied', label: 'Applied' },
  { value: 'interview_scheduled', label: 'Interview Scheduled' },
  { value: 'approved', label: 'Approved' },
  { value: 'rejected', label: 'Rejected' },
];

export const SOURCES = [
  'Walk-in',
  'Referral',
  'Website',
  'Instagram',
  'Facebook',
  'LinkedIn',
  'Agent',
  'Online Lead',
  'Other',
];
